module Meevo.Components.Common {
  /**
  * Contract to hold string constants used through out the client side application.
  * Using static get() functions so that the members can't be changed by anyone
  */
  export class Constants {

    /**
    * Session Storage Lookup Keys
    */
    public static get SS_LOCATION_OVERRIDE(): any { return "overrideLocation"; }
    public static get SS_LOCATION_SEARCH_CRITERIA(): any { return "locationSearch"; }


    /**
     * Regular Expressions
     */
      public static get REGEX_EMAIL_VALIDATOR(): any { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/; }

      /*THIS WAS PREVIOUS REGEX BUT DIDNT VALIDATE*/
      /*public static get REGEX_EMAIL_VALIDATOR(): any { return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/; }*/

    public static get REGEX_PHONE_VALIDATOR(): any { return /^\d{10,15}$/; }
    public static get REGEX_PHONE_LASTFOUR_VALIDATOR(): any { return /^\d{4}$/; }
    public static get REGEX_CANADA_POSTAL_CODE(): any { return /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/; }
    public static get REGEX_UK_POSTAL_CODE(): any {return /^(?:(?:[A-PR-UWYZ][0-9]{1,2}|[A-PR-UWYZ][A-HK-Y][0-9]{1,2}|[A-PR-UWYZ][0-9][A-HJKSTUW]|[A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]) [0-9][ABD-HJLNP-UW-Z]{2}|GIR 0AA)$/;}
    public static get REGEX_URL(): any {return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;}

    /**
    * Recent map keys
    */
    public static get RECENT_KEY_CLIENT(): any { return "client"; }

    /**
    * Tracking keys
    */
    public static get TRACK_PAGE_VIEW(): any { return "pageView"; }

    /**
     * Call Center Emulation key
     */
    public static get CALL_CENTER_EMULATION_STORAGE(): any { return "callcenterEmulationLocationData" }

    /**
     * A maximum int constant that aligns with maximum C#/.NET Int32 (in constrast with ES2015 Number.MAX_SAFE_INTEGER which is too large).
     */
    public static get MAX_INT_VALUE(): number { return 2147483647 };
  }
}
